import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Button, ButtonGroup } from 'reactstrap';
import { connect } from 'react-redux'
import { push } from 'react-router-redux';
import { ROAD_BOOKING_SEARCH_PATH } from '../../../../config/paths';
import Loader from '../../../common/Loader';
import { clearRoadBookingItinerary, getItineraryFoodGroup, getRoadBookingStopsLocation, searchItineraryRoadBooking } from '../../../../actions';

const RoadBookingSegment = ({ itineraryIdSelected, dispatchPush, dispatchGetRoadBookingStopsLocation, stopsLocationList, loading, dispatchSearchItineraryRoadBooking, dispatchClearRoadBookingItinerary, dispatchGetItineraryFoodGroup }) => {

  useEffect(() => {
    if (!itineraryIdSelected) {
      dispatchPush(ROAD_BOOKING_SEARCH_PATH)
      return
    }
    dispatchClearRoadBookingItinerary()
    dispatchGetRoadBookingStopsLocation(itineraryIdSelected);
    dispatchGetItineraryFoodGroup(itineraryIdSelected);
  }, [itineraryIdSelected]);

  const [stopLocationIdSelected, setStopLocationIdSelected] = useState(null);

  const handleStopLocationClick = (stopId) => {
    if (stopLocationIdSelected !== null && stopLocationIdSelected === stopId) {
      return
    }
    setStopLocationIdSelected(stopId);
    dispatchSearchItineraryRoadBooking({ destinationLocationId: stopId, itineraryId: itineraryIdSelected });
  }

  let content = null;

  if (loading) {
    content = <Loader />
  }
  else if (stopsLocationList.length === 0) {
    content = <p>No hay paradas disponibles.</p>
  }
  else if (stopsLocationList) {
    content = (
      <ButtonGroup className='modal-fullscreen' size="lg">
        {stopsLocationList.map((stop) => (
          <Button
            key={stop.id}
            color="primary"
            outline
            onClick={() => handleStopLocationClick(stop.id)}
            active={stopLocationIdSelected === stop.id}
          >
            {stop.name}
          </Button>
        ))}
      </ButtonGroup>
    )
  }

  return (
    <div className='mt-2'>
      {content}
    </div>
  )
}

RoadBookingSegment.propTypes = {
  itineraryIdSelected: PropTypes.number.isRequired,
  dispatchPush: PropTypes.func.isRequired,
  dispatchGetRoadBookingStopsLocation: PropTypes.func.isRequired,
  stopsLocationList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  loading: PropTypes.bool.isRequired,
  dispatchSearchItineraryRoadBooking: PropTypes.func.isRequired,
  dispatchClearRoadBookingItinerary: PropTypes.func.isRequired,
  dispatchGetItineraryFoodGroup: PropTypes.func.isRequired,
}

const mapStateToProps = ({ BookingUnit }) => ({
  itineraryIdSelected: BookingUnit.Booking.getIn(['roadBooking', 'itineraryId']),
  stopsLocationList: BookingUnit.Booking.getIn(['roadBooking', 'stopsLocationList']),
  loading: !BookingUnit.Booking.getIn(['roadBooking', 'activity']).isEmpty(),
})

const mapDispatchToProps = {
  dispatchPush: push,
  dispatchGetRoadBookingStopsLocation: getRoadBookingStopsLocation,
  dispatchSearchItineraryRoadBooking: searchItineraryRoadBooking,
  dispatchClearRoadBookingItinerary: clearRoadBookingItinerary,
  dispatchGetItineraryFoodGroup: getItineraryFoodGroup,
}

export default connect(mapStateToProps, mapDispatchToProps)(RoadBookingSegment);
